import React from 'react';
import { Link } from 'react-router-dom';

/* Юридические страницы платформы «ИНФА СОТКА».
   Тексты составлены под 152-ФЗ. Перед публичным запуском рекомендуется
   разовая вычитка юристом — спорные места отмечены в README/комментариях. */

const PLATFORM = 'ИНФА СОТКА';
const UPDATED = '17 июня 2026 г.';

const OPERATOR = {
  name: 'ИП Пальчиков Артём Александрович',
  inn: '231131305845',
  ogrnip: '314231114800040',
  email: 'artpalchikov@yandex.ru',
};

function Doc({ title, children }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f0f4f8', padding: '32px 16px', fontFamily: "'Inter', -apple-system, sans-serif" }}>
      <div style={{ maxWidth: 820, margin: '0 auto', background: '#fff', borderRadius: 16, boxShadow: '0 10px 40px rgba(0,0,0,0.08)', padding: '40px 44px' }}>
        <Link to="/" style={{ color: '#7c4dff', fontWeight: 600, fontSize: 14, textDecoration: 'none' }}>← На главную</Link>
        <h1 style={{ fontSize: 26, fontWeight: 800, color: '#0f172a', margin: '18px 0 6px' }}>{title}</h1>
        <div style={{ fontSize: 13, color: '#94a3b8', marginBottom: 24 }}>Последнее обновление: {UPDATED}</div>
        <div style={{ fontSize: 14.5, color: '#334155', lineHeight: 1.7 }}>{children}</div>
        <div style={{ marginTop: 32, paddingTop: 20, borderTop: '1px solid #e2e8f0', fontSize: 13, color: '#64748b', lineHeight: 1.7 }}>
          <b>Оператор:</b> {OPERATOR.name}<br />
          ИНН: {OPERATOR.inn} · ОГРНИП: {OPERATOR.ogrnip}<br />
          Контакт: <a href={`mailto:${OPERATOR.email}`} style={{ color: '#7c4dff' }}>{OPERATOR.email}</a>
        </div>
      </div>
    </div>
  );
}

const H = ({ children }) => <h2 style={{ fontSize: 17, fontWeight: 700, color: '#0f172a', margin: '22px 0 8px' }}>{children}</h2>;
const P = ({ children }) => <p style={{ margin: '0 0 10px' }}>{children}</p>;

export function PrivacyPage() {
  return (
    <Doc title="Политика обработки персональных данных">
      <H>1. Общие положения</H>
      <P>Настоящая Политика определяет порядок обработки и защиты персональных данных пользователей образовательной платформы «{PLATFORM}» (далее — Платформа) Оператором ({OPERATOR.name}) и принята в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».</P>
      <P>Используя Платформу и проходя регистрацию, пользователь подтверждает согласие с условиями настоящей Политики.</P>

      <H>2. Какие данные обрабатываются</H>
      <P>Оператор обрабатывает следующие персональные данные:</P>
      <P>— имя (и фамилия) пользователя;<br />
      — адрес электронной почты;<br />
      — данные об обучении: прогресс по урокам, ответы на домашние задания, результаты проверки;<br />
      — технические данные: IP-адрес, дата и время входа на вебинары, данные сессии (токен авторизации в браузере пользователя).</P>
      <P>Оператор не обрабатывает специальные категории персональных данных (о здоровье, расовой принадлежности, политических взглядах и т.п.) и биометрические данные.</P>

      <H>3. Цели обработки</H>
      <P>— предоставление доступа к Платформе, учебным материалам и записям вебинаров;<br />
      — ведение учёта успеваемости и проверка домашних заданий;<br />
      — связь с пользователем (приглашения, уведомления, восстановление доступа);<br />
      — обеспечение безопасности и работоспособности Платформы.</P>

      <H>4. Правовые основания обработки</H>
      <P>Обработка осуществляется на основании согласия субъекта персональных данных, а также в целях исполнения договора (предоставления доступа к образовательным услугам), стороной которого является пользователь.</P>

      <H>5. Условия и порядок обработки</H>
      <P>Обработка персональных данных осуществляется смешанным способом (с использованием средств автоматизации и без таковых). Доступ к данным имеет только Оператор.</P>

      <H>6. Сроки хранения</H>
      <P>Персональные данные хранятся в течение всего периода использования Платформы и до момента отзыва согласия субъектом персональных данных. После отзыва согласия или прекращения использования Платформы данные удаляются в срок, не превышающий 30 дней, за исключением случаев, когда их хранение требуется по закону.</P>

      <H>7. Хранение и передача третьим лицам</H>
      <P>Хранение и обработка персональных данных осуществляется на серверах, расположенных на территории Российской Федерации.</P>
      <P>Для функционирования Платформы Оператор привлекает следующих лиц, осуществляющих обработку по поручению Оператора:</P>
      <P>— хостинг-провайдер (размещение сервера и базы данных) — на территории РФ;<br />
      — облачное хранилище Яндекс Облако (Yandex Cloud) — хранение учебных файлов и записей, на территории РФ;<br />
      — сервис отправки электронной почты — для уведомлений и приглашений.</P>
      <P>В иных целях и иным лицам персональные данные не передаются, за исключением случаев, предусмотренных законодательством РФ.</P>

      <H>8. Права субъекта персональных данных</H>
      <P>Пользователь вправе получить информацию об обработке своих данных, потребовать их уточнения, блокирования или удаления, а также отозвать согласие на обработку. Для этого необходимо направить обращение на контактный email Оператора, указанный ниже.</P>

      <H>9. Несовершеннолетние</H>
      <P>Если пользователю менее 18 лет, согласие на обработку его персональных данных даёт законный представитель (родитель или опекун), подтверждая его при регистрации. Регистрируя несовершеннолетнего, законный представитель подтверждает своё согласие.</P>

      <H>10. Изменение Политики</H>
      <P>Оператор вправе изменять настоящую Политику. Актуальная редакция всегда доступна на данной странице. Дата последнего обновления указана вверху документа.</P>
    </Doc>
  );
}

export function ConsentPage() {
  return (
    <Doc title="Согласие на обработку персональных данных">
      <P>Отмечая соответствующее поле при регистрации на платформе «{PLATFORM}», я свободно, своей волей и в своём интересе даю согласие Оператору ({OPERATOR.name}, ИНН {OPERATOR.inn}) на обработку моих персональных данных: имени, адреса электронной почты, данных об обучении (прогресс, ответы на задания) и технических данных (IP-адрес, данные сессии).</P>
      <P>Согласие даётся в целях предоставления доступа к Платформе и учебному процессу, ведения учёта успеваемости и связи со мной.</P>
      <P>Согласие распространяется на следующие действия: сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), использование, передачу лицам, привлечённым Оператором для обработки на территории РФ, блокирование, удаление и уничтожение. Обработка осуществляется смешанным способом (автоматизированно и без использования средств автоматизации).</P>
      <P>Если мне менее 18 лет, согласие даётся моим законным представителем (родителем или опекуном), который подтверждает его, отмечая поле при регистрации.</P>
      <P>Согласие действует с момента его предоставления и до момента отзыва. Я уведомлён(а), что могу отозвать согласие в любой момент, направив письменное обращение на email Оператора: {OPERATOR.email}.</P>
      <P>Я ознакомлен(а) с <Link to="/privacy" style={{ color: '#7c4dff' }}>Политикой обработки персональных данных</Link> и принимаю её условия.</P>
    </Doc>
  );
}

export function TermsPage() {
  return (
    <Doc title="Пользовательское соглашение">
      <H>1. Предмет соглашения</H>
      <P>Настоящее Соглашение регулирует отношения между Оператором ({OPERATOR.name}) и пользователем при использовании образовательной платформы «{PLATFORM}» — онлайн-подготовки к ОГЭ и ЕГЭ по информатике (далее — Платформа).</P>

      <H>2. Регистрация и учётная запись</H>
      <P>Доступ к Платформе предоставляется по приглашению или после регистрации. Пользователь обязуется указывать достоверные данные, обеспечивать конфиденциальность своих учётных данных и не передавать доступ третьим лицам. Ответственность за действия, совершённые под учётной записью, несёт пользователь.</P>

      <H>3. Использование Платформы</H>
      <P>Пользователю предоставляется доступ к учебным материалам, вебинарам, их записям и домашним заданиям в личных образовательных целях. Запрещается копировать, распространять, публиковать или иным образом передавать учебные материалы и записи третьим лицам без письменного согласия Оператора.</P>

      <H>4. Интеллектуальная собственность</H>
      <P>Все материалы Платформы (тексты, видеозаписи, задания, оформление) являются объектами интеллектуальной собственности Оператора и охраняются законом. Доступ к материалам не означает передачи каких-либо исключительных прав.</P>

      <H>5. Персональные данные</H>
      <P>Обработка персональных данных пользователя осуществляется в соответствии с <Link to="/privacy" style={{ color: '#7c4dff' }}>Политикой обработки персональных данных</Link>.</P>

      <H>6. Ответственность</H>
      <P>Платформа предоставляется на условиях «как есть». Оператор прилагает разумные усилия для бесперебойной работы Платформы, но не гарантирует отсутствие технических сбоев. Оператор не несёт ответственности за результаты экзаменов, зависящие от усилий самого пользователя.</P>

      <H>7. Изменение условий</H>
      <P>Оператор вправе изменять настоящее Соглашение. Актуальная редакция доступна на данной странице. Продолжение использования Платформы после изменений означает согласие с новой редакцией.</P>
    </Doc>
  );
}
